import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { createStructuredSelector } from 'reselect';
import { injectIntl } from 'react-intl';
import { hot } from 'react-hot-loader';
import { compose } from 'ramda';
import { withRouter } from 'react-router';

import { ExperiencesListItem } from './experiencesListItem.component';
import { AnalyticsActions } from '../../../modules/analytics';

const mapStateToProps = createStructuredSelector({});

export const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {
      logGTMEvent: AnalyticsActions.logGTMEvent,
    },
    dispatch
  );

export default compose(
  hot(module),
  connect(
    mapStateToProps,
    mapDispatchToProps
  ),
  injectIntl,
  withRouter
)(ExperiencesListItem);
